import { tma_add_status_message } from '@/scripts/imports/helpers/toasts'
import { button_pending, button_reset } from '@/scripts/imports/helpers/forms'

/**
 * Remove Empty Paragraph
 * @description Removes the first paragraph block if it is empty.
 */
export const removeEmptyParagraph = () => {
    const firstParagraph = document.querySelector('.ce-block .ce-paragraph')
    if (firstParagraph && !firstParagraph.textContent.trim()) {
        firstParagraph.closest('.ce-block').remove()
    }
}

/**
 * Check for Base64 Images
 * @description Scans EditorJS content for Base64-encoded images.
 * @param {Object} content - The EditorJS content blocks.
 * @returns {Boolean} Returns true if Base64 images exist, otherwise false.
 */
export const checkIfBase64ImagesExist = (content) => {
    if (!content || !Array.isArray(content.blocks)) return false
    for (const block of content.blocks) {
        if ((block.type === 'image' || block.type === 'attaches')) {
            const url = block?.data?.url || block?.data?.file?.url
            if (url && url.startsWith('data:image')) {
                return true
            }
        }
    }
    return false
}